import axios from 'axios'

const baseurl = `${process.env.VUE_APP_API_URL}`
const url = `${baseurl}/api/v1`
class StageEightService {
  static createStageEight (data) {
    return axios.post(`${url}/app/stage-eight/create`, data)
  }
}

export default StageEightService
